import React, { useEffect, useRef } from "react";
import clsx from "clsx";
import SoccerTracker from "./tracker";
import SportsTeamLogo from "components/teamLogo";
import style from "./style.module.scss";
import SoccerViewRecord from "./record";
import SoccerViewRegular from "./regular";
import { observer } from "mobx-react";
import TextLengthTooltipDiv from "../../../../components/textLengthTooltip/div";
import useStore from "../../../../hooks/useStore";
import { v4 as uuidv4 } from "uuid";
import Banner from "../../../../components/banner";

const SoccerView = observer(
  ({ item, isSelected, setSelectedGame, isPopup }) => {
    const { oddsData, getProgressTime, gameStatus, getTeamData, winnerTeam } =
      item;
    const { soccerTime, isActiveTime } = getProgressTime;
    const { bannerStore } = useStore();

    const itemId = useRef(uuidv4()).current;
    useEffect(() => {
      if (
        !bannerStore.activeMajorViewId ||
        bannerStore.activeMajorViewId === "placeholder"
      ) {
        bannerStore.setActiveMajorView(itemId);
      }
    }, [itemId, bannerStore, bannerStore.activeMajorViewId]);

    const onClickDetail = () => {
      window.open(
        `/match/soccer/${item.id}`,
        `detail_${item.id}`,
        "width=1000px,height=901px,scrollbars=yes"
      );
    };

    // const onClickVideo = () => {
    //   window.open(
    //     item.videoLink,
    //     `live_${item.id}`,
    //     "width=980px,height=750px,scrollbars=yes"
    //   );
    // };

    const onClickVideo = () => {
      getStreamBrowser(item.videoLink);
    };
    const onClickBetble = () => {
      let type = 0;

      if (item.getTracker.status === "progress") {
        type = 1;
      }

      const url = `https://betble.com/game/game.php?type=${type}${item.betbleUri}`;

      window.open(url);
    };

    const setSelectedItem = () => {
      setSelectedGame(
        isSelected,
        item.id,
        item.startDatetime,
        item.gameStatus,
        "soccer"
      );
    };

    return (
      <>
        <div className={style.score_board}>
          {/* tracker  */}
          <SoccerTracker
            item={item}
            tracker={item.getTracker}
            typeData={item.getTypeData}
            isPopup={isPopup}
          />
          {/*// tracker  */}

          {/* summary_score  */}
          <div className={style.summary_score}>
            <div className={style.info}>
              <span className={style.league}>{item.league.shortName}</span>
              <span className={style.time}>{item.getStartDateTime}</span>
              <span
                className={clsx(
                  style.state,
                  item.getTracker.status === "progress" && style.on
                )}
              >
                {gameStatus === "IN_PROGRESS" && isActiveTime && (
                  <strong
                    style={{ color: "#ee1a21" }}
                  >{`${soccerTime}'`}</strong>
                )}
                {item.statusText}
              </span>
            </div>
            <div className={style.team_area}>
              <div className={clsx(style.team, style.away)}>
                <SportsTeamLogo
                  imgSize={"55"}
                  imgUrl={!!item.teams ? item.teams.away.imgPath : null}
                  isLazy={true}
                />
                <TextLengthTooltipDiv
                  name={getTeamData.away.name}
                  className={style.name}
                  maxLength={10}
                />
                <div
                  className={clsx(
                    style.point,
                    winnerTeam.activeScore === "away" && style.on
                  )}
                >
                  {getTeamData.away.score}
                  {getTeamData.isPk && (
                    <span className={style.pk}>
                      ({getTeamData.away.pkScore})
                    </span>
                  )}
                </div>
              </div>
              <div className={clsx(style.team, style.home)}>
                <SportsTeamLogo
                  imgSize={"55"}
                  imgUrl={!!item.teams ? item.teams.home.imgPath : null}
                  isLazy={true}
                />
                <TextLengthTooltipDiv
                  name={getTeamData.home.name}
                  className={style.name}
                  maxLength={10}
                />
                <div
                  className={clsx(
                    style.point,
                    winnerTeam.activeScore === "home" && style.on
                  )}
                >
                  {getTeamData.home.score}
                  {getTeamData.isPk && (
                    <span className={style.pk}>
                      ({getTeamData.home.pkScore})
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className={style.btn_area}>
              {!isPopup && (
                <>
                  <button
                    className={clsx(
                      style.btn,
                      style.btn_arrow,
                      isSelected ? style.down : style.up
                    )}
                    onClick={setSelectedItem}
                  >
                    올리기/내리기
                  </button>
                  <button
                    className={clsx(style.btn, style.popup)}
                    onClick={onClickDetail}
                  >
                    상세보기
                  </button>
                  {/*{itemId}*/}
                  {/*{item.betbleButtonVisible && (*/}
                  {/*  <button*/}
                  {/*    className={clsx(style.btn, style.betting)}*/}
                  {/*    onClick={onClickBetble}*/}
                  {/*  >*/}
                  {/*    베팅*/}
                  {/*  </button>*/}
                  {/*)}*/}
                  {!!item.videoLink && ( item.gameStatus === "IN_PROGRESS" || item.gameStatus === "BREAK_TIME" || item.gameStatus === "PAUSE" ) && (
                    <button
                      className={clsx(style.btn, style.btn_live)}
                      onClick={onClickVideo}
                    >
                      생중계
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
          {/*// summary_score  */}

          {/* detail_score  */}
          <div className={clsx(style.detail_score)}>
            {item.getTracker.status === "ready" ? (
              <div className={style.board}>
                <SoccerViewRecord
                  home={item.teams.home}
                  away={item.teams.away}
                />
              </div>
            ) : (
              <SoccerViewRegular item={item} />
            )}
          </div>
          <div className={style.odds_info}>
            <dl className={style.item}>
              <dt>국내</dt>
              <dd>
                <span>
                  {!!oddsData.domestic.away && oddsData.domestic.away}
                </span>
                <span>
                  {!!oddsData.domestic.awayOption &&
                    oddsData.domestic.awayOption}
                </span>
              </dd>
              <dd>
                <span>
                  {!!oddsData.domestic.home && oddsData.domestic.home}
                </span>
                <span>
                  {!!oddsData.domestic.homeOption &&
                    oddsData.domestic.homeOption}
                </span>
              </dd>
            </dl>
            <dl className={style.item}>
              <dt>해외</dt>
              <dd>
                <span>
                  {!!oddsData.international.away && oddsData.international.away}
                </span>
                <span>
                  {!!oddsData.international.awayOption &&
                    oddsData.international.awayOption}
                </span>
              </dd>
              <dd>
                <span>
                  {!!oddsData.international.home && oddsData.international.home}
                </span>
                <span>
                  {!!oddsData.international.homeOption &&
                    oddsData.international.homeOption}
                </span>
              </dd>
            </dl>
          </div>
          {/*// detail_score  */}
        </div>
        {bannerStore.activeMajorViewId === itemId ? (
          <Banner paddingTop="10px" paddingBottom="0" />
        ) : null}
      </>
    );
  }
);

export default SoccerView;
